import React from 'react';
import { Field } from 'formik';
import { CheckBoxSection } from 'styles/components/CheckboxInput';
const CheckboxInput = (props) => (
  <Field name={props?.name}>
    {({ form }) => (
      <CheckBoxSection
        className={` responsive checkbox-field ${props.className} ${props?.disabled && 'checkBoxDisable'}`}
      >
        <label className="checkbox-container">
          <input
            {...props}
            checked={form.values[props?.name] ? form.values[props?.name] : false}
            className="checkBox"
            type="checkbox"
            onChange={(e) => {
              form.setFieldValue(props?.name, e.target.checked);
              props?.onChange && props?.onChange(e.target.checked, props?.label);
            }}
          />
          <span className='checkmark' />
          {props?.label}
        </label>

      </CheckBoxSection>
    )}
  </Field>
);

export default CheckboxInput;